import getClient from '../../react-commons/utils/graphql';
import { GetIntegratedPartnersQuery } from './queries';

export default (): void => {
  getClient().preload(GetIntegratedPartnersQuery, undefined, 'GET');
};
